'use client'
import { Flex, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import ChevronRight from '@/assets/icons/chevron-right.svg'
import { I18nLink } from '@/i18n/navigation'

export default function CategoriesHeader({
  category,
  categoriesHref = '/price/categories',
}: {
  category?: string
  categoriesHref?: string
}) {
  const t = useTranslations()
  return (
    <Flex align={'center'} mb={32}>
      <I18nLink href={'/'} prefetch={true}>
        <Text c={'var(--content-secondary)'} variant={'subtitle'}>
          {t('common.coinCategoryTypes.allCoins')}
        </Text>
      </I18nLink>
      <ChevronRight height={16} fill={'var(--content-tertiary)'} />
      <I18nLink href={categoriesHref} prefetch={true}>
        <Text variant={'subtitle'} c={'var(--content-primary)'}>
          {t('category.categories')}
        </Text>
      </I18nLink>
      {category && (
        <>
          <ChevronRight height={16} fill={'var(--content-tertiary)'} />
          <Text variant={'subtitle'} c={'var(--content-primary)'}>
            {category}
          </Text>
        </>
      )}
    </Flex>
  )
}
